import component from './PhPassword.vue_vue&type=script&lang.js';
export { default } from './PhPassword.vue_vue&type=script&lang.js';
import { render } from './PhPassword.vue_vue&type=template&id=8111a372&lang.js';

component.render = render;
